module.exports = __webpack_public_path__ + "img/tu_20.8a425024.jpg";